// The Stripe price each Checkout session in this tab was opened for, keyed by the
// session id Stripe puts on the return page. Monthly and annual prices share one
// product, so after a same-tier switch to annual the user doc matches the purchased
// product_id before the annual price lands — only the price proves the switch did.
const storageKey = (sessionId: string) => `checkoutPrice:${sessionId}`;

export function rememberCheckoutPrice(sessionId: string, priceId: string): void {
  try {
    sessionStorage.setItem(storageKey(sessionId), priceId);
  } catch {
    // Storage blocked: CheckoutSuccess falls back to its product check. Never block checkout on it.
  }
}

/** The price `sessionId` was opened for, or null when this tab didn't record one. */
export function getCheckoutPrice(sessionId: string): string | null {
  try {
    return sessionStorage.getItem(storageKey(sessionId));
  } catch {
    return null;
  }
}
